import { toTruncated } from '@/utilities/formatting';
import { Badge } from '@simplywallst/ui-core/next';

type Props = {
  prevFairValue: number | null | undefined;
  currentFairValue: number | null | undefined;
};

export const NarrativeUpdateFairValueBadge = ({
  prevFairValue,
  currentFairValue,
}: Props) => {
  if (!prevFairValue || !currentFairValue) return null;

  const changePercentage =
    ((currentFairValue - prevFairValue) / prevFairValue) * 100;

  const significance = Math.abs(changePercentage) >= 10 ? 0 : 2;

  if (changePercentage === 0) return null;

  if (changePercentage < 0)
    return (
      <Badge tone="bad" variant="solid" size="small">
        Fair value Decreased{' '}
        {toTruncated(Math.abs(changePercentage), significance)}%
      </Badge>
    );

  return (
    <Badge tone="good" variant="solid" size="small">
      Fair value Increased {toTruncated(changePercentage, significance)}%
    </Badge>
  );
};
